export const ECONDA_SESSION_ID_COOKIE = 'emos_jcsid'
export const ECONDA_VISITOR_ID_COOKIE = 'emos_jcvid'
